export default __webpack_public_path__ + "static/media/recent-fridge.0f7548f9.png";